import { usePerformanceClient } from '@depict-ai/react-ui';
import { translateObjectData } from '../../utils/locale';
import { generateEventId, urlify } from '../../utils/string';

const receiptAnalytics = (order, setup, fromList = {}) => {
	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
	const { items, totals, currency, discounts = {}, address = {} } = order;
	const uniqueEventID = generateEventId();
	const coupon = discounts.vouchers.reduce((acc, obj) => [...acc, obj.voucher], []).join(', ');
	const { dpc } = usePerformanceClient();

	window.dataLayer.push({ values: null });
	window.dataLayer.push({
		event: 'Purchase',
		event_id: uniqueEventID,
		values: {
			currency,
			content_type: 'product',
			contents: items.map((item) => ({
				id: `1/${setup.country.toLowerCase()}-${item.id}-s`,
				quantity: item.quantity,
				item_price: item.priceEachAsNumber,
			})),
			num_items: items.length,
			value: totals.grandTotalPriceAsNumber,
		},
	});

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'PurchaseEvent',
		ecommerce: {
			currencyCode: currency,
			purchase: {
				actionField: {
					id: order.order,
					affiliation: '',
					revenue: totals.grandTotalPriceAsNumber,
					tax: totals.grandTotalPriceTaxAsNumber,
					shipping: totals.shippingPriceAsNumber,
					coupon,
				},
				products: items.map((item) => ({
					name: item.name,
					sku: item.sku,
					id: item.id.replace(/p(\d+)-v.*/, '$1'),
					price: item.priceEachAsNumber,
					brand: item.brand,
					category: item.category,
					variant: item.variant,
					quantity: item.quantity,
				})),
			},
		},
	});

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'purchase_ga4',
		ecommerce: {
			'x-fb-event_id': uniqueEventID,
			currency,
			value: totals.grandTotalPriceAsNumber,
			tax: totals.grandTotalPriceTaxAsNumber,
			shipping: totals.shippingPriceAsNumber,
			transaction_id: order.order,
			coupon,
			items: items.map((item) => {
				const localizedItem = translateObjectData(setup, item);
				const itemCategory = localizedItem.category && localizedItem.category.split('/').reduce((acc, category, j) => ({ ...acc, [`item_category${j > 0 ? j + 1 : ''}`]: category }), {});

				return {
					item_name: item.name,
					item_id: item.id.replace(/p(\d+)-v.*/, '$1'),
					price: item.priceEachAsNumber,
					currency,
					...(itemCategory || {}),
					item_list_id: urlify(fromList[item.id] || ''),
					item_list_name: fromList[item.id] || '',
					item_brand: item.brand,
					item_variant: item.variant,
					quantity: item.quantity,
				};
			}),
			user_data: {
				email: address.email,
				address: {
					first_name: address.firstName,
					last_name: address.lastName,
					street: address.address1,
					postal_code: address.zipCode,
					region: address.state,
					city: address.city,
					country: address.country,
				},
			},
		},
	});

	dpc.sendPurchaseEvent({
		transaction_id: order.order,
		items: items.map((item) => (
			{ item_id: item.sizeSku, price: item.priceEachAsNumber, quantity: item.quantity }
		)),
		currency,
	});
};

export default receiptAnalytics;
